import { HistoryOutput, History } from './history.model';
import { KeyValuePair } from './keyValueItem.model';
import { Image } from './image.model';
import { SortType } from './sortType.model';
import { DateType } from '../enums/date-type';
import { UserType } from '../enums/user-type';

export interface Slrn {
  id: number;
  value: string;
}

export class MvPoleDetails {
  id: number = 0;
  slrn: Slrn;
  guid: string = '';
  dtName: string = '';
  address: string = '';
  upriserNumber: string = '';
  poleNumber: string = '';
  feeder11Name: string = '';
  poleType: string = '';
  status: string = '';
  dataQualityStatus: string = '';
  poleId: string = '';
  buildingsSLRN: string = '';
  buildingsSLRNList: string[] = [];
  isChecked: boolean;
  area: string = '';
  region: string = '';
  subGeographicalRegionName: string = '';
  geographicalRegionName: string = '';
  acLineName: string = '';
  showDropdown: boolean = false;

  constructor(data?: any) {
    this.id = data?.id ?? 0;
    this.slrn = data?.slrn ?? '';
    this.guid = data?.guid ?? '';
    this.dtName = data?.dtName ?? '';
    this.address = data?.address ?? '';
    this.upriserNumber = data?.upriserNumber ?? '';
    this.poleNumber = data?.poleNumber ?? '';
    this.feeder11Name = data?.feeder11Name ?? '';
    this.poleType = data?.poleType ?? '';
    this.status = data?.status ?? '';
    this.dataQualityStatus = data?.dataQualityStatus ?? '';
    this.poleId = data?.poleId ?? '';
    this.buildingsSLRN = data?.buildingsSLRN ?? '';
    this.isChecked = data?.isChecked ?? false;
    this.area = data?.area ?? '';
    this.region = data?.region ?? '';
    this.subGeographicalRegionName = data?.subGeographicalRegionName ?? '';
    this.geographicalRegionName = data?.geographicalRegionName ?? '';
    this.acLineName = data?.acLineName ?? '';
    this.buildingsSLRNList = data?.buildingsSLRN
      ? data?.buildingsSLRN.split(',')
      : [];
    this.showDropdown = false;
  }
}

export class EditMvPole {
  id: number = 0;
  slrn: string = '';
  latitude: number = 0;
  longitude: number = 0;
  address: string = '';
  landmark: string = '';
  guid: string = '';
  dtName: string = '';
  dtId: string = '';
  upriserNumber: string = '';
  poleNumber: string = '';
  feeder11Name: string = '';
  feeder33Name: string = '';
  feederNumber: string = '';
  region: string = '';
  district: string = '';
  districtId: number = 0;
  dtNumber: string = '';
  poleType: string = '';
  status: string = '';
  assignedUser: string = '';
  assignedUserId: number = 0;
  dataQualityId: number = 0;
  dataQualityStatus: string = '';
  images: Image[];
  poleShape: string = '';
  poleCondition: string = '';
  poleNote: string = '';
  poleStructure: string = '';
  crossArm: string = '';
  crossArmCondition: string = '';
  poleId: string = '';
  lastUpdateUser: string = '';
  creationDate: string = '';
  lastUpdate: string = '';
  reassignedBy: string = '';
  validatedBy: string = '';
  validationDate: string = '';
  auditedBy: string = '';
  auditedDate: string = '';
  auditedStatus: string = '';
  postCode?: string;
  postCodeException?: string;
  history: HistoryOutput;
  firstCapturedUser: string;
  streetLight: string;
  streetLightSource: string;
  wattage: string;
  meansOfIsolation: string;
  state: string;
  comment: string = '';
  lvReticulation: string = '';
  transmissionStation: string = '';
  injectionSubstation: string = '';
  subGeographicalRegionName: string = '';
  geographicalRegionName: string = '';
  acLineName: string = '';
  substationName: string = '';
  incomingAcLineName: string = '';
  transmissionSubstationName: string = '';
  poleHistories: History[];
  dataValidationReview: KeyValuePair[] = [];
  insulators?: Insulators;
  groundingSystem?: GroundingSystem;
  stayWire?: StayWire;

  constructor(data?: any) {
    this.id = data?.id ?? 0;
    this.slrn = data?.slrn ?? '';
    this.latitude = data?.latitude ?? 0;
    this.longitude = data?.longitude ?? 0;
    this.address = data?.address ?? '';
    this.guid = data?.guid ?? '';
    this.dtName = data?.dtName ?? '';
    this.dtId = data?.dtId ?? '';
    this.upriserNumber = data?.upriserNumber ?? '';
    this.poleNumber = data?.poleNumber ?? '';
    this.feeder11Name = data?.feeder11Name ?? '';
    this.feeder33Name = data?.feeder33Name ?? '';
    this.feederNumber = data?.feederNumber ?? '';
    this.region = data?.region ?? '';
    this.district = data?.district ?? '';
    this.districtId = data?.districtId ?? 0;
    this.dtNumber = data?.dtNumber ?? '';
    this.poleType = data?.poleType ?? '';
    this.status = data?.status ?? '';

    this.assignedUser = data?.assignedUser ?? '';
    this.assignedUserId = data?.assignedUserId ?? 0;
    this.dataQualityId = data?.dataQualityId ?? 0;
    this.dataQualityStatus = data?.dataQualityStatus ?? '';
    this.images = data?.images?.length
      ? data?.images.map((el: any) => new Image(el))
      : [];
    this.poleShape = data?.poleShape ?? '';
    this.poleCondition = data?.poleCondition ?? '';
    this.poleNote = data?.poleNote ?? '';
    this.poleStructure = data?.poleStructure ?? '';
    this.crossArm = data?.crossArm ?? '';
    this.crossArmCondition = data?.crossArmCondition ?? '';
    this.poleId = data?.poleId ?? '';
    this.lastUpdateUser = data?.lastUpdateUser ?? '';
    this.creationDate = data?.creationDate ?? '';
    this.lastUpdate = data?.lastUpdate ?? '';
    this.reassignedBy = data?.reassignedBy ?? '';
    this.validatedBy = data?.validatedBy ?? '';
    this.validationDate = data?.validationDate ?? '';
    this.auditedBy = data?.auditedBy ?? '';
    this.auditedDate = data?.auditedDate ?? '';
    this.auditedStatus = data?.auditedStatus ?? '';
    this.postCode = data?.postCode ?? '';
    this.postCodeException = data?.postCodeException ?? '';
    this.history = new HistoryOutput(data?.history);
    this.firstCapturedUser = data?.firstCapturedUser ?? '';
    this.streetLight = data?.streetLight ?? '';
    this.streetLightSource = data?.streetLightSource ?? '';
    this.wattage = data?.wattage ?? '';
    this.meansOfIsolation = data?.meansOfIsolation ?? '';
    this.state = data?.state ?? '';
    this.comment = data?.comment ?? '';
    this.poleHistories = data?.poleHistories?.length
      ? data?.poleHistories.map((el: any) => new History(el))
      : [];
    this.dataValidationReview = data?.dataValidationReview ?? [];
    this.lvReticulation = data?.lvReticulation ? 'Yes' : 'No';
    this.landmark = data?.closestLandmark ?? '';
    this.transmissionStation = data?.transmissionStation ?? '';
    this.injectionSubstation = data?.injectionSubstation ?? '';
    this.subGeographicalRegionName = data?.subGeographicalRegionName ?? '';
    this.geographicalRegionName = data?.geographicalRegionName ?? '';
    this.acLineName = data?.acLineName ?? '';
    this.substationName = data?.substationName ?? '';
    this.incomingAcLineName = data?.incomingAcLineName ?? '';
    this.transmissionSubstationName = data?.transmissionSubstationName ?? '';
    this.insulators = data?.insulators
      ? (data.insulators as Insulators)
      : undefined;
    this.groundingSystem = data?.groundingSystem
      ? (data.groundingSystem as GroundingSystem)
      : undefined;
    this.stayWire = data?.stayWire ? (data.stayWire as StayWire) : undefined;
  }
}

export class MvPoleStats {
  total: number = 0;
  numberOf11KvFeeders: number = 0;
  retagged: number = 0;
  lvReticulation: number = 0;
  goodCondition: number = 0;

  constructor(data?: any) {
    this.total = data?.total;
    this.numberOf11KvFeeders = data?.numberOf11KvFeeders;
    this.retagged = data?.retagged;
    this.lvReticulation = data?.lvReticulation;
    this.goodCondition = data?.goodCondition;
  }
}

export class MvPoleSave {
  id: number = 0;
  poleNumber: string = '';
  poleType: string = '';
  poleShape: string = '';
  poleCondition: string = '';
  poleStructure: string = '';
  address: string = '';
  closestLandmark: string = '';
  assignedUserId: number = 0;
  history?: HistoryOutput;

  constructor(data?: any) {
    this.id = data?.id ?? 0;
    this.poleNumber = data?.poleNumber ?? '';
    this.address = data?.address ?? '';
    this.closestLandmark = data?.closestLandmark ?? '';
    this.poleType = data?.poleType ?? '';
    this.poleShape = data?.poleShape ?? '';
    this.poleCondition = data?.poleCondition ?? '';
    this.poleStructure = data?.poleStructure ?? '';
    this.assignedUserId = data?.assignedUserId ?? 0;
    this.history = new HistoryOutput(data?.history);
  }
}

export enum Insulators {
  Pin = 1,
  Pot = 2,
  Disc = 3,
  PolymerSuspension = 4,
}

export enum GroundingSystem {
  Solid = 1,
  Resistance = 2,
  Reactance = 3,
  Resonant = 4,
}

export enum StayWire {
  No = 0,
  Yes = 1,
}

export enum MvPoleStatsOptions {
  Total = 1,
  Kv11Feeders = 2,
  Retagged = 3,
  LvReticulation = 4,
  GoodCondition = 5,
}

export class MvPoleFilter {
  search: string = '';
  filterBy: string = '';
  userType: UserType | null = null;
  sortBy: SortType = SortType.NEWEST;
  dateFrom: string | null = null;
  dateTo: string | null = null;
  dateType: DateType = DateType.LastUpdateTime;
  selectedAreas: number[] = [];
  status: number | null = null;
  type: number | null = null;
  selectedIds: number[] = [];
  selectedUsers: number[] = [];
  selectedSubGeographicalRegions: number[] = [];
  slnrValues?: string[];
}

export class MvPoleAppliedFilter {
  id?: number;
  label: string = '';
  value: any = '';
}

export enum SortByOptions {
  NEWEST = 1,
  SLRN_ASC = 2,
  SLRN_DESC = 3,
  ID_ASC = 4,
  ID_DESC = 5,
}

export enum PoleType {
  Concrete = 1,
  Wooden = 2,
  Steel = 3,
}

export enum PoleCondition {
  Good = 1,
  BentLeaning = 2,
  Vandalized = 3,
}

export enum PoleShape {
  Round = 1,
  Square = 2,
}

export enum PoleStructure {
  HPole = 1,
  Single = 2,
  ThreePoles = 3,
  FourPoles = 4,
}
